import React from 'react';
import { promotionTypes } from '../data/vehicleData.js';

const PromotionSelector = ({ selectedPromotion, onPromotionChange }) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-gray-800">Promotion Type</h3>
      
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {promotionTypes.map((promo) => (
          <div
            key={promo.id}
            onClick={() => onPromotionChange(promo.id)}
            className={`p-3 border-2 rounded-lg cursor-pointer transition-all duration-200 text-center ${
              selectedPromotion === promo.id
                ? 'border-blue-500 bg-blue-50'
                : 'border-gray-200 bg-white hover:border-gray-300'
            }`}
          >
            <h4 className="font-medium text-gray-800 text-sm">{promo.name}</h4>
            {promo.text && (
              <div className="mt-2 px-2 py-1 bg-red-500 text-white text-xs font-bold rounded">
                {promo.text}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default PromotionSelector;